import { render, staticRenderFns } from "./UnconfirmedEvents.vue?vue&type=template&id=3249f412&scoped=true&"
import script from "./UnconfirmedEvents.vue?vue&type=script&lang=js&"
export * from "./UnconfirmedEvents.vue?vue&type=script&lang=js&"
import style0 from "./UnconfirmedEvents.vue?vue&type=style&index=0&id=3249f412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3249f412",
  null
  
)

export default component.exports